module["exports"] = [
  "601 ### ###",
  "737 ### ###",
  "736 ### ###",
  "### ### ###",
  "+420 ### ### ###",
  "00420 ### ### ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/cz/phone_number/formats.js
// module id = 239
// module chunks = 0